import React, { useContext, Suspense } from 'react';
import { AuthContext } from '../App';
import Dashboard from './Dashboard';
import { SystemDashboard } from './system';

const DashboardRouter = () => {
  const { user } = useContext(AuthContext);

  // Show loading while user data is being fetched
  if (!user) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600"></div>
      </div>
    );
  }

  if (user.role === 'system_admin') {
    return (
      <Suspense fallback={
        <div className="flex items-center justify-center h-64">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600"></div>
        </div>
      }>
        <SystemDashboard />
      </Suspense>
    );
  }

  return <Dashboard />;
};

export default DashboardRouter;
